function switchToMydlinkLang(locale) {
  let language = locale;

  if (
    language.toLowerCase() === 'pt-br' ||
    language.toLowerCase() === 'pt_br' ||
    language.toLowerCase() === 'pt-pt'
  ) {
    language = 'pt';
  }
  if (
    language.toLowerCase() === 'zh-tw' ||
    language.toLowerCase() === 'zh-hk' ||
    language.toLowerCase() === 'zh'
  ) {
    language = 'zh_TW';
  }
  if (language.toLowerCase() === 'zh-cn') {
    language = 'zh_CN';
  }
  if (
    language.toLowerCase() === 'en-us' ||
    language.toLowerCase() === 'en-gb' ||
    language.toLowerCase() === 'en-gb-oxendict' ||
    language.toLowerCase() === 'en-za' ||
    language.toLowerCase() === 'en-nz' ||
    language.toLowerCase() === 'en-in' ||
    language.toLowerCase() === 'en-ca' ||
    language.toLowerCase() === 'en-au'
  ) {
    language = 'en';
  }

  return language;
}

export default switchToMydlinkLang;



// WEBPACK FOOTER //
// ./src/helper/switchToMydlinkLang.js